import React, { Component } from 'react'
import '../styles/DatePicker.css'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import '../styles/ReactDates.css'
import CalendarIcon from '../images/Booking/calendar-icon.png'
import moment from 'moment'
import 'moment/locale/fr'
import smoothscroll from 'smoothscroll'
import { injectIntl, defineMessages } from "react-intl"
import isInclusivelyBeforeDay from 'react-dates/lib/utils/isInclusivelyBeforeDay'
import isInclusivelyAfterDay from 'react-dates/lib/utils/isInclusivelyAfterDay'
import utils from '../utils.json'

const getWeekDay = (date, lang) => {
  if (lang === "fr") {
    return date.format('LLLL').split(' ').shift()
  } else {
    return `${date.format('LLLL').split(' ').shift().substring(0, 3)} .`
  }
}

const limitsInWeeks = utils.weekLimit

const limitMoment = moment().add(limitsInWeeks, 'w').subtract(1, 'day')

class DatePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false,
    }
  }

  getStartOfWeek = (date) => {
    if (this.props.lang === "fr") {
      return date.startOf('week')
    } else {
      return date.startOf('week').add(1, 'days')
    }
  }

  handleDate = (date) => {
    return this.props.selectedTheme === "all"
      ? date
      : this.getStartOfWeek(date)
  }

  handleChange = (date) => {
    return this.props.selectedTheme === "all"
      ? this.props.handleChange(date)
      : this.props.handleChange(this.getStartOfWeek(date))
  }

  handleOpenDatePicker = async () => {
    await this.setState({ focused: true })
    smoothscroll(document.querySelector('.SingleDatePicker_picker__directionLeft_2'))
  }

  handleCalendarClick = () => {
    this.setState({ focused: true })
  }

  datePickerStyle = () => {
    if (this.props.selectedTheme === "all" && this.props.klass === "date-picker--tb") {
      return "date-picker date-picker--all date-picker--tb"
    } else if (this.props.selectedTheme === "all") {
      return "date-picker date-picker--all"
    } else if (this.props.klass === "date-picker--tb") {
      return "date-picker date-picker--tb"
    } else {
      return "date-picker"
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className={this.datePickerStyle()}>
        <span
          className={this.props.date > moment() ? "date-picker-arrow" : "date-picker-arrow date-picker-arrow--hidden"}
          onClick={() => {
            this.props.selectedTheme === "all"
              ? this.props.handleChange(this.props.date.subtract(1, 'days'))
              : this.props.handleChange(this.props.date.subtract(1, 'weeks'))
            }}>
        </span>
        <div className={this.props.klass === "date-picker--tb" ? "date-picker-tb-wrapper" : null} onClick={this.handleOpenDatePicker}>
          <SingleDatePicker
            id="datePicker"
            date={this.handleDate(this.props.date)}
            onDateChange={date => this.handleChange(date)}
            focused={this.state.focused}
            onFocusChange={({ focused }) => this.setState({ focused })}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            daySize={32}
            readOnly
            isOutsideRange={ day => isInclusivelyAfterDay(day, limitMoment) || isInclusivelyBeforeDay(day, moment()) }
            displayFormat={() => moment.localeData(this.props.lang).longDateFormat('ll')}
          />
        </div>
        <div className="calendar" onClick={() => this.handleCalendarClick()}>
          <img src={CalendarIcon} alt="calendar"/>
        </div>
        <span
          className={`date-picker-arrow date-picker-arrow--right ${this.props.date < limitMoment.clone().subtract(1, 'day') ? "" : "date-picker-arrow--hidden"}`}
          onClick={() => {
            this.props.selectedTheme === "all"
              ? this.props.handleChange(this.props.date.add(1, 'days'))
              : this.props.handleChange(this.props.date.add(1, 'weeks'))
            }}>
        </span>
        {
          this.props.selectedTheme !== "all"
          ?
            <span className="date-picker-week-of">
              {formatMessage(messages.weekOf)}
            </span>
          : <span className="date-picker-week-of date-picker-day-of">
              {getWeekDay(this.props.date, this.props.lang)}
            </span>
        }
      </div>
    )
  }
}

const messages = defineMessages({
  weekOf: {
    id: 'datePicker.weekOf',
    defaultMessage: 'Semaine du'
  }
})

export default injectIntl(DatePicker)



// WEBPACK FOOTER //
// ./src/components/DatePicker.js